const fieldController = {
  data () {
    return {
      controllers: {},
      dataModel: {},
      validData: true
    }
  },
  beforeCreate () {
    this.$on('registerController', (params) => {
      this.registerController(params)
    });
    this.$on('updateFieldValue', (params) => {
      this.updateFieldValue(params)
    })
  },
  methods: {
    emitFieldsErrors (params) {
      for (let controller in this.controllers) {
        this.controllers[controller].controller.$emit('setfieldsErrorMessage', {
          fieldsErrors: params
        });
      }
    },
    async validateController (controller) {
      await controller.controller.validateFields();
      if (!controller.controller.validData) {
        W_LOGGER('Data Container | ', 'ERROR IN ' + controller.controllerName + ' Controller');
        this.validData = false;
        return false;
      }

      return true;
    },
    async validateControllers () {
      this.validData = true;
      for (let controller in this.controllers) {
        await this.validateController(this.controllers[controller]);
      }
      return this.validData;
    },
    registerController (params) {
      this.controllers[params.controller.controllerName] = {
        controller: params.controller,
        name: params.controller.controllerName,
        value: null
      }
    },
    updateFieldValue (params) {
      let update = {
        name: params.field.name
      };

      this.dataModel[params.field.name] = params.field.field_value
    },
    fetchData () {
      this.dataModel = {};
      let cModel = null;
      for (let controller in this.controllers) {
        cModel = this.controllers[controller].controller.dataModel;
        for (let x in cModel) {
          this.dataModel[x] = cModel[x]
        }
      }
    }
  }
};

export default fieldController
